import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-038ebf45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "p-mt-3 p-p-3 bg-color-secondary p-d-flex p-jc-between" }
const _hoisted_3 = { class: "p-text-bold" }
const _hoisted_4 = {
  key: 0,
  class: "p-mx-3 p-p-2"
}
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "เลขติดตามพัสดุ", -1))
const _hoisted_7 = { class: "p-ml-auto" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "p-d-flex"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "จัดส่งโดย", -1))
const _hoisted_11 = { class: "p-ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "รายละเอียดการจัดส่ง (ราคาสุทธิ " + _toDisplayString(_ctx.grandTotal) + ")", 1)
    ]),
    (_ctx.trackingNo.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.trackingNo.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    href: _ctx.trackingNo.urlLink,
                    class: "text-tracking"
                  }, _toDisplayString(`${_ctx.trackingNo.text}`), 9, _hoisted_8)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.trackingNo.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.shippingTypeName), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}